// external dependencies
import React, { Component } from 'react'
import { string } from 'prop-types'
import styled from '@emotion/styled'

// file import
import spinnerGif from 'content/images/rfqWidget/spinner_blue.gif'

// constants
import { MQ, MIN_RFQ_HEIGHT, MAX_RFQ_WIDTH } from 'utils/styleHelpers'

// styled components
const SpinnerContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	min-height: ${MIN_RFQ_HEIGHT};
	height: 100%; // for ie11 compatibility
	z-index: 9999;
	margin-top: -30px;

	${MQ.M} {
		max-width: ${MAX_RFQ_WIDTH.M};
	}

	${MQ.L} {
		max-width: ${MAX_RFQ_WIDTH.L};
	}
`

const Spinner = styled.img`
	width: 100px;
`

const BzWidget = styled.div`
	background-color: #fff;
	box-sizing: border-box;
	min-height: 550px;
	height: 100%; // for ie11 compatibility
	position: relative;
	width: 100%;
	z-index: 0;
`

const propTypes = {
	animationType: string.isRequired,
	catId: string.isRequired,
	keywordId: string.isRequired,
	pubId: string.isRequired,
}

class RfqWidget extends Component {
	state = {
		isLoading: true,
	}

	componentDidMount() {
		this.setState({
			isLoading: false,
		})
	}

	render() {
		const { isLoading } = this.state
		const { animationType, catId, keywordId } = this.props

		return (
			<BzWidget id="bzWidget">
				{/* SpinnerContainer is replaced by widget when rfq loaded */}
				<SpinnerContainer>
					<Spinner src={spinnerGif} />
				</SpinnerContainer>
				{!isLoading &&
					(function(w, d, s, c, p, n, t, k) {
						var i,
							a = [],
							u = `//${process.env.GATSBY_RFQ_BASE}/apps/bz-rfq-ui/`,
							v = '.js?_=' + new Date().getTime()
						function f(q, g) {
							var x = d.createElement(s),
								o = d.getElementsByTagName(s)[0]
							x.onload = x.onreadystatechange = function(_, k) {
								if (k || !x.readyState || /loaded|complete/.test(x.readyState)) {
									x.onload = x.onreadystatechange = null
									x = undefined
									if (!k) {
										if (g) g()
									}
								}
							}
							x.async = 1
							x.src = q
							o.parentNode.insertBefore(x, o)
						}
						for (i = 0; i < n.length; i++) {
							if (d.getElementById(n[i])) {
								a.push(n[i])
							}
						}
						if (a.length) {
							f(u + 'manifest' + v, function() {
								f(u + 'vendor' + v, function() {
									f(u + 'app' + v, function() {
										w.BZ.init({
											animationType: t,
											contIds: a,
											catId: c,
											flowId: 2278,
											keywordId: k,
											pubId: p,
										})
									})
								})
							})
						}
					})(
						window,
						document,
						'script',
						catId,
						process.env.GATSBY_RFQ_PUB_ID,
						['bzWidget'],
						animationType,
						keywordId
					)}
			</BzWidget>
		)
	}
}

RfqWidget.propTypes = propTypes

export default RfqWidget
